








































































































































































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";

//@ts-ignore
import indicador_administradores from '@/mixins/axios/indicador_administradores'


//@ts-ignore
import indicador_variables from '@/mixins/axios/indicador_variables'
//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
import VueHtml2pdf from "vue-html2pdf";
import bootstrap from "!raw-loader!./bootstrap.css";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import VueAxios from "vue-axios";
import axios from "axios";
@Component({
  components: {OrganizationChart},

  data() {
    return {
  nombre:null as any,
secretaria:null as any,
departamento:null as any,
clave:null as any,
clasificacion:null as any,
unidad_medida_resultado:null as any,
objetivo_indicador:null as any,
frecuencia:null as any,
meta:null as any,
valor_max:null as any,
valor_min:null as any,
motivo:null as any,
aceptado:null as any,
tipo:null as any,
formula:null as any,
dimension: "" as any,
      nivel: "" as any,
      tendencia: "" as any,
      tipo_meta: "" as any,
      movimiento: "" as any,
      persona_responsable: "" as any,
      claridad: "" as any,
      relevancia: "" as any,
      economica: "" as any,
      monitoreable: "" as any,
      adecuado: "" as any,
      aportacion_marginal: "" as any,

      semaforo_verde: "" as any,
      semaforo_amarillo: "" as any,
      semaforo_rojo: "" as any,
        variables_indicadores:[] as any,
 indicador_variablesdata:[] as any,
   selectedvar:0,

    };
  },
  mixins: [
 indicador_variables,
 indicador_administradores
  ],
  methods: {
    AsingarVariable(){
          if(this.selectedvar!=0){
let data=this.indicador_variablesdata.filter(item => item.id ==this.selectedvar)[0];
let variable={
indicador_variables_id:data.id
};
 this.variables_indicadores.push(variable);
          }

         
      },
searchVar(id){
  
    if(this.variables_indicadores.filter(item => item.indicador_variables_id ==id).length>0){
        return true;

    }else{
        return false;
    }
    
},
async getVariables() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_VARIABLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_variablesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
  async onClick() {
       var sTable = document.getElementById('tablaIndicador').innerHTML;
              await axios({
                    url: this.$store.state.baseapi+"pdf",
                    method: 'POST',
                    data:{
                      html:sTable,
                      title:"Ficha Indicador 2020",
                      id:this.$store.state.user.usuario.id_municipio
                    },
                    responseType: 'blob'
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.pdf');
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
          },

          
 async getIndicador() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')
let data2={
id:this.$store.state.indicador_administrador,

};


let data= await this.GET_ADMINISTRADORESHOW(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       //this.problema_select=response; 
                       this.nombre=response.nombre;
                       this.secretaria=response.secretaria;
                           this.departamento=response.departamento;
                       this.clave=response.clave;
                       this.clasificacion=response.clasificacion;
 this.unidad_medida_resultado=response.unidad_medida_resultado;
  this.objetivo_indicador=response.objetivo_indicador;
   this.frecuencia=response.frecuencia;
 
     this.valor_max=response.valor_max;
this.valor_min=response.valor_min;
this.motivo=response.motivo;
this.aceptado=response.aceptado;
this.tipo=response.tipo;

this.formula=response.formula;
  this.dimension = response.dimension;
      this.nivel = response.nivel;
      this.tendencia = response.tendencia;
      this.tipo_meta = response.tipo_meta;
      this.movimiento = response.movimiento;
      this.persona_responsable = response.persona_responsable;
      this.claridad = response.claridad;
      this.relevancia = response.relevancia;
      this.economica = response.economica;
      this.monitoreable = response.monitoreable;
      this.adecuado = response.adecuado;
      this.aportacion_marginal = response.aportacion_marginal;
this.meta = response.meta;
this.semaforo_rojo = response.semaforo_rojo;
this.semaforo_verde = response.semaforo_verde;
this.semaforo_amarillo = response.semaforo_amarillo;
this.variables_indicadores=response.variables_indicadores;
console.log(this.variables_indicadores);
            

//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

  },
  created() {},
  mounted() {
    this.getIndicador();
       this.getVariables();
   /// this.getDataActividadLinea();
    //this.getDataAvanceFisico();
   // getDataAvanceFinanciero();
  },
})
export default class Home extends Vue {

  // @Prop() private id !:any;
}
